import { Renderer } from '../../RichTextEditor';
import { useFields } from './Fields.Context';
import { useCurrentUser } from 'hooks/useCurrentUser';
import type { Styles } from 'generated/graphql';
import { useReporterStyles } from 'hooks/useReporterStyles';
import { useReadOnlyHeadingLabelSet } from 'hooks/useReadOnlyHeadingLabelSet';
import { UnifiedEditor } from '../../RichTextEditor/ui/UnifiedEditor';
import { Stack } from 'common/ui/Layout';
import { css } from 'styled-components';
import { telemetryContextFor } from 'modules/Apollo/types';

export const FieldsSectionRenderer = (): React.ReactElement => {
  const [{ content }] = useFields();
  const { data } = useCurrentUser({ context: APOLLO_QUERY_CONTEXT });
  const reporterSettings = data?.me?.reporterSettings;

  const style: Styles = useReporterStyles(reporterSettings);

  // RP-6070 (M2b): style heading-like paragraphs in the read-only view when the flag is on.
  const headingLabelSet = useReadOnlyHeadingLabelSet({ context: APOLLO_QUERY_CONTEXT });

  return (
    <Stack
      data-stack-stretch
      css={css`
        max-height: 100%;
      `}
      space="small"
      stretchX
      stretchY
    >
      <UnifiedEditor isAddendumEditor={false} isDisabled={true} variant="view">
        <Renderer content={content} style={style} headingLabelSet={headingLabelSet} />
      </UnifiedEditor>
    </Stack>
  );
};

FieldsSectionRenderer.displayName = 'FieldsSectionRenderer';

const APOLLO_QUERY_CONTEXT = telemetryContextFor(FieldsSectionRenderer);
